module.exports = __webpack_public_path__ + "static/media/5x5-rubber.d26c485c.png";